export const THALAMUS_AI_FUNCTIONALITY_ID = 273

export function isThalamusAiUiEnabled() {
    return String(process.env.VUE_APP_THALAMUS_AI_ENABLED || '').toLowerCase() === 'true'
}

export function canAccessThalamusAi(funcionalidades = []) {
    if (!isThalamusAiUiEnabled()) {
        return false
    }

    const ids = Array.isArray(funcionalidades) ? funcionalidades : []
    return ids.includes(THALAMUS_AI_FUNCTIONALITY_ID)
}
